import { PureComponent } from "react";

import { StatusDisplay, type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export enum ChoiceStatus {
    Unreleased = -1,
    Pending = 0,
    DeclinedByOwner = 1,
    Selected = 2,
    BuilderOverride = 3,
    Unavailable = 4,
    DeclinedByBuilder = 5,
    PartiallyComplete = 6,
    // The following statuses are only used in the WebAPI and are not saved to the DB
    Locked = 7,
    PendingPriceRequestedByOwner = 8,
}

export const ApprovedChoiceStatuses = [ChoiceStatus.Selected, ChoiceStatus.BuilderOverride];

const declined = "Declined";
const approved = "Selected";
const pending = "Pending";
export const ChoiceStatusDescription = new Map<ChoiceStatus, string>([
    [ChoiceStatus.Unreleased, "Unreleased"],
    [ChoiceStatus.Pending, pending],
    [ChoiceStatus.PendingPriceRequestedByOwner, pending],
    [ChoiceStatus.DeclinedByBuilder, declined],
    [ChoiceStatus.DeclinedByOwner, declined],
    [ChoiceStatus.Selected, approved],
    [ChoiceStatus.BuilderOverride, approved],
    [ChoiceStatus.Unavailable, "Unavailable"],
    [ChoiceStatus.PartiallyComplete, "Partially Complete"],
    [ChoiceStatus.Locked, "Locked"],
]);

export const ChoiceStatusType = (status: ChoiceStatus): StatusTypes => {
    switch (status) {
        case ChoiceStatus.Selected:
        case ChoiceStatus.BuilderOverride:
        case ChoiceStatus.PartiallyComplete:
            return "success";
        case ChoiceStatus.DeclinedByBuilder:
        case ChoiceStatus.DeclinedByOwner:
            return "danger";
        case ChoiceStatus.Pending:
        case ChoiceStatus.PendingPriceRequestedByOwner:
            return "pending";
        default:
            return "";
    }
};

interface ISelectionChoiceStatusProps {
    status: ChoiceStatus;
    details?: string | JSX.Element | null;
}

export class SelectionChoiceStatus extends PureComponent<ISelectionChoiceStatusProps> {
    render = () => {
        const { status, details } = this.props;
        return <StatusDisplay statusType={ChoiceStatusType(status)}>{details}</StatusDisplay>;
    };
}

interface ISelectionChoiceStatusTagProps {
    status: ChoiceStatus;
}

export class SelectionChoiceStatusTag extends PureComponent<ISelectionChoiceStatusTagProps> {
    render = () => {
        const { status } = this.props;
        return (
            <StatusTagDisplay
                statusText={ChoiceStatusDescription.get(status)!.toUpperCase()}
                statusType={ChoiceStatusType(status)}
            />
        );
    };
}

interface ISelectionChoiceApprovalStatusProps {
    status: ChoiceStatus;
    approvalStatusDetails: string;
}

export class SelectionApprovalStatusInformation extends PureComponent<ISelectionChoiceApprovalStatusProps> {
    private getStatusImage = (status: ChoiceStatus) => {
        switch (status) {
            case ChoiceStatus.Selected:
                return "/images/Common/status/OwnerApprove.png";
            case ChoiceStatus.BuilderOverride:
                return "/images/Common/status/BuilderApprove.png";
            case ChoiceStatus.DeclinedByBuilder:
            case ChoiceStatus.DeclinedByOwner:
                return "/images/Common/status/declinedItem.png";
            default:
                return ""; // Don't show image as it shouldn't show this container in this status
        }
    };

    render = () => {
        return (
            <>
                <img src={this.getStatusImage(this.props.status)} alt="approval status" />{" "}
                <span>{this.props.approvalStatusDetails}</span>
            </>
        );
    };
}
